const SESSION_KEY = 'savedAllcourses';

export const saveAllCourses = (data) => {
  window.localStorage.setItem(SESSION_KEY, JSON.stringify(data));
};

export const getAllCourses = () => {
  const session = window.localStorage.getItem(SESSION_KEY);
  if (session) {
    return JSON.parse(session);
  }
  return null;
};

export const destroyAllCourses = () => {
  window.localStorage.removeItem(SESSION_KEY);
};

export default {
  saveAllCourses, getAllCourses, destroyAllCourses,
};
